import { USER_SETTINGS_KEY } from '../AppConstants';
import { UserSettings } from '../types/UserSettings';

export const getUserSettings = (): UserSettings | null => {
    const localStore = localStorage.getItem(USER_SETTINGS_KEY);

    if (!localStore) return null;

    try {
        return JSON.parse(localStore);
    } catch {
        return null;
    }
};
